import {
  getMsalInstance,
  getMsalClientId,
  resolveMailcallAccessToken,
} from '../../auth/msalConfig';
import { MSAL_MAILCALL_ACCESS_TOKEN_KEY } from '../../msalBootstrap';

/**
 * One-shot token from OAuth bootstrap (sessionStorage) or MSAL cache (silent).
 */
export async function getMicrosoftMailAccessToken() {
  let accessToken = sessionStorage.getItem(MSAL_MAILCALL_ACCESS_TOKEN_KEY);
  if (accessToken) {
    sessionStorage.removeItem(MSAL_MAILCALL_ACCESS_TOKEN_KEY);
    return accessToken;
  }
  if (!getMsalClientId()) {
    return null;
  }
  const msal = getMsalInstance();
  await msal.initialize();
  return resolveMailcallAccessToken(msal);
}
